import {AcquisitionClosedReasonEnum} from '@/enums/institutioner/acquisition/AcquisitionClosedReason.enum';
import colors from 'vuetify/lib/util/colors';
import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum AcquisitionListStatusEnum {
    OPEN, COMMITTED, CLOSED, IN_PROGRESS, POTENTIAL, AI_SUCCESS,
}

export namespace AcquisitionListStatusEnum {
    export function getChartDisplay(state: AcquisitionListStatusEnum, reason?: AcquisitionClosedReasonEnum): {
        text: string;
        color: string
    } {
        return {
            text: getChartLabel(state, reason),
            color: getChartColor(state, reason),
        }
    }

    type Data = {
        text: string;
        color: string;
        icon: string;
        _sort: number;
    }

    export const Record: Record<AcquisitionListStatusEnum, Data> = {
        [AcquisitionListStatusEnum.OPEN]: {
            text: 'Offen',
            color: 'black',
            icon: 'mdi-account-clock',
            _sort: 0,
        },
        [AcquisitionListStatusEnum.POTENTIAL]: {
            text: 'Potenzial',
            color: 'lime',
            icon: 'mdi-alarm-light-outline',
            _sort: 1,
        },
        [AcquisitionListStatusEnum.AI_SUCCESS]: {
            text: 'AI Erfolg',
            color: 'teal',
            icon: 'mdi-brain',
            _sort: 2,
        },

        [AcquisitionListStatusEnum.IN_PROGRESS]: {
            text: 'In Arbeit',
            color: 'info',
            icon: 'mdi-briefcase',
            _sort: 3,
        },
        [AcquisitionListStatusEnum.COMMITTED]: {
            text: 'Zusage',
            color: 'success',
            icon: 'mdi-check',
            _sort: 4,
        },
        [AcquisitionListStatusEnum.CLOSED]: {
            text: 'Absage',
            color: 'error',
            icon: 'mdi-cancel',
            _sort: 5,
        },
    };

    export const Items = mapRecordToItems(Record);
    Items.sort((a, b) => a._sort - b._sort);
}

function getChartLabel(status: AcquisitionListStatusEnum, reason?: AcquisitionClosedReasonEnum): string {
    const statusLabel = AcquisitionListStatusEnum.Record[status]?.text ?? '-';
    if (reason) {
        const reasonLabel = AcquisitionClosedReasonEnum.Record[reason].text ?? '';
        return `${statusLabel} - ${reasonLabel}`;
    }
    return statusLabel;
}

function getChartColor(status: AcquisitionListStatusEnum, reason?: AcquisitionClosedReasonEnum): string {
    switch (status) {
        case AcquisitionListStatusEnum.OPEN:
            return colors.blueGrey.darken4;
        case AcquisitionListStatusEnum.IN_PROGRESS:
            return colors.blue.base;
        case AcquisitionListStatusEnum.AI_SUCCESS:
            return colors.teal.base;
        case AcquisitionListStatusEnum.COMMITTED:
            return colors.green.base;
        case AcquisitionListStatusEnum.POTENTIAL:
            return colors.lime.base;
        case AcquisitionListStatusEnum.CLOSED:
            if (reason) {
                switch (reason) {
                    case AcquisitionClosedReasonEnum.NON_COMMERCIAL:
                        return colors.red.base;
                    case AcquisitionClosedReasonEnum.COMPETITOR:
                        return colors.red.accent1;
                    case AcquisitionClosedReasonEnum.COOPERATION_CANCELLED:
                        return colors.red.accent2;
                    case AcquisitionClosedReasonEnum.NO_ROOM:
                        return colors.red.lighten3;
                    case AcquisitionClosedReasonEnum.OTHER:
                        return colors.red.darken3;
                    default:
                        return colors.red.accent1;
                }
            } else {
                return colors.red.base;
            }
        default:
            return '#8c634c';
    }
}
